import { useState, useEffect } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { Link } from "react-router-dom";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

import "./index.css";

const Header = ({ t, className }: { t: TFunction; className?: string }) => {
  const [visible, setVisibility] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [closingDropdown, setClosingDropdown] = useState<number | null>(null);

  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const [dropdownDirection, setDropdownDirection] = useState<{
    [key: number]: string;
  }>({});

  useEffect(() => {
    const handleScroll = () => {
      const headerHeight =
        (document.querySelector(".parallax-container") as HTMLElement)
          ?.offsetHeight || 0;
      setIsSticky(window.scrollY > headerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const menuItems = [
    { title: t("navAbout"), link: "/About" },
    {
      title: t("navApps"),
      link: "/AtlassianApps",
      subpages: [
        { title: t("navSubRecycleBin"), link: "/AtlassianApps/JRB" },
        { title: t("navSubTrafficLights"), link: "/AtlassianApps/JTL" },
        { title: t("navSubLogViewerJ"), link: "/AtlassianApps/JLV" },
        { title: t("navSubAttachmentScannerC"), link: "/AtlassianApps/CAS" },
        { title: t("navSubCustomResources"), link: "/AtlassianApps/JCR" },
        { title: t("navSubAnnounceIt"), link: "/AtlassianApps/JIT" },
        { title: t("navSubLogViewerB"), link: "/AtlassianApps/BLV" },
        { title: t("navSubDatabaseConsole"), link: "/AtlassianApps/JDC" },
        { title: t("navSubDynamic"), link: "/AtlassianApps/JDU" },
        { title: t("navSubAttachmentScannerJ"), link: "/AtlassianApps/JAS" },
      ],
    },
    {
      title: t("navServices"),
      link: "/Services",
    },
    { title: t("navContact"), link: "/Contact", isButton: true },
  ];

  const handleMouseEnter = (
    index: number,
    e: React.MouseEvent<HTMLDivElement>
  ) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const distanceToTop = rect.top;
    const distanceToBottom = window.innerHeight - rect.bottom;
    const direction = distanceToBottom < distanceToTop ? "dropup" : "dropdown";

    setDropdownDirection((prev) => ({ ...prev, [index]: direction }));
    setActiveDropdown(index);
  };

  const handleMouseLeave = () => {
    setClosingDropdown(activeDropdown);
    setTimeout(() => {
      setActiveDropdown(null);
      setClosingDropdown(null);
    }, 300); // match your .3s animation
  };

  const MenuItem = () => {
    return (
      <div className="navbar-main">
        {menuItems.map((item, index) =>
          item.isButton ? (
            <CustomNavLinkSmall
              key={index}
              style={{ width: "180px", display: "inline-block" }}
              onClick={() => setVisibility(false)}
              className="contact-link"
            >
              <Link to={item.link}>
                <Span>
                  <Button>{item.title}</Button>
                </Span>
              </Link>
            </CustomNavLinkSmall>
          ) : (
            <div
              key={index}
              className="menu-item"
              style={{ display: "inline-block" }}
              onMouseEnter={
                item.subpages ? (e) => handleMouseEnter(index, e) : undefined
              }
              onMouseLeave={item.subpages ? handleMouseLeave : undefined}
            >
              <CustomNavLinkSmall onClick={() => setVisibility(false)}>
                <Link to={item.link}>
                  <Span>{item.title}</Span>
                </Link>
              </CustomNavLinkSmall>
              {/* Render the dropdown only if subpages exist and this item is active */}
              {item.subpages &&
                (activeDropdown === index || closingDropdown === index) && (
                  <div
                    className={
                      `submenu ` +
                      `${dropdownDirection[index]} ` +
                      `${closingDropdown === index ? "exit" : ""}`
                    }
                  >
                    {item.subpages.map((subitem, subIndex) => (
                      <div
                        key={subIndex}
                        className="submenu-item"
                        onClick={() => setVisibility(false)}
                      >
                        <Link to={subitem.link}>
                          <Span>{subitem.title}</Span>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
            </div>
          )
        )}
      </div>
    );
  };

  return (
    <HeaderSection className={className}>
      <Container className={`navbar ${isSticky ? "sticky" : ""} ${className}`}>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <img
              src="/img/logos/t2consult-header-logo.png"
              alt="Logo"
              className={`nav-logo ${isSticky ? "visible" : "hidden"}`}
            />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
